<template>
    <div class="bg_fff">
        <div class="container">
            <div class="bg_fff pt5 pr5 pb5 pl5 width100 box">
                <Breadcrumb :pages="pages">
                    <span slot="append" class="fs14 color_main ml20 underline pointer flright append" @click="$router.back()">返回上一页</span>
                </Breadcrumb>
                <div class="flex jcb">
                    <dept-list class="width74" :list="deptList"></dept-list>
                    <order-rule class="width25"></order-rule>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DeptList from "../../components/appointment/dept"
    import OrderRule from "../../components/appointment/order-rule"
    import {orderTime} from "../../lib/cache/OrderTime";
    import Breadcrumb from "../../components/common/Breadcrumb";

    export default {
    name: "DepartmentSelect",
    data() {
      return {
        form: {},
        hosInfo:{},
        deptList:[],
          pages:[]
      }
    },
    computed: {},
    components: {DeptList, OrderRule,Breadcrumb},
    mixins: [],
    created() {
      this.hosInfo = orderTime.get();
      this.pages = ['预约挂号',this.hosInfo.hosName]
    },
    mounted() {
      this.getDept()

    },
    methods: {
      async getDept(){
        const {code,list} = await this.$http('smarthos.yygh.ApiDepartmentService.oneClassDepartmentList',{hosId:this.hosInfo.hosId})
        this.deptList = list
      },
    }
  }
</script>

<style scoped lang="scss">
    .container {
        background-color: #f0f0f0;
        padding: 10px;
        margin: 0 auto;
        color: #333333;
    }
    .box{
        margin: 0 auto;
    }
    .underline{
        text-decoration: underline;
    }
    .flright{
        float: right;
    }
    .border_under{
        border-bottom: 1px solid #E8E8E8;
    }
    .append{
        position: absolute;
        right: 0;
    }
</style>